import React, { FC } from 'react';
import { Box } from '@mui/material';
import { MAIN_CURRENCY } from '@okletsplay/core';
import {
  MostWinLeaderboard,
  BiggestWinLeaderboard,
  MostPlayedGamesLeaderboard,
} from 'app/interfaces/entity';
import { LeaderboardCard } from 'modules/leaderboards/components/LeaderboardCard';
import { FormatCurrency, FormatCurrencyType } from 'shared/components/Format/Currency';

interface LeaderboardCarouselSlideProps {
  mostWin?: MostWinLeaderboard;
  biggestWin?: BiggestWinLeaderboard;
  mostPlayedGames?: MostPlayedGamesLeaderboard;
}

export const LeaderboardCarouselSlide: FC<LeaderboardCarouselSlideProps> = ({
  biggestWin,
  mostWin,
  mostPlayedGames,
}) => {
  const currency = MAIN_CURRENCY;

  return (
    <Box display="flex" flexDirection="column">
      {biggestWin && (
        <LeaderboardCard
          title="Biggest Win"
          user={biggestWin.user}
          rank={biggestWin.rank}
          gameIcon={biggestWin.game.icon}
          gameTitle={biggestWin.game.title}
          value={
            <FormatCurrency
              variant="title"
              type={FormatCurrencyType.None}
              amount={biggestWin.winningAmount}
              currency={currency}
            />
          }
        />
      )}
      {mostWin && (
        <LeaderboardCard
          title="Total Winnings"
          user={mostWin.user}
          rank={mostWin.rank}
          gameIcon={mostWin.game.icon}
          gameTitle={mostWin.game.title}
          value={
            <FormatCurrency
              variant="title"
              type={FormatCurrencyType.None}
              amount={mostWin.winningAmount}
              currency={currency}
            />
          }
        />
      )}
      {mostPlayedGames && (
        <LeaderboardCard
          title="Most Games Played"
          user={mostPlayedGames.user}
          rank={mostPlayedGames.rank}
          gameTitle={mostPlayedGames.game.title}
          gameIcon={mostPlayedGames.game.icon}
          value={mostPlayedGames.playedGames}
        />
      )}
    </Box>
  );
};
